<template>
  <b-breadcrumb :items="items" class="breadcrumb"></b-breadcrumb>
</template>

<script>
  export default {
    name: 'Breadcrumb',
    props: {
      items: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style scoped>
.breadcrumb {
  margin-bottom: 0 !important;
  background: #4A90E2;
  border-radius: 0;
  font-size: 14px;
}
.breadcrumb-item a {
  color: white;
}
.breadcrumb-item.active {
  color: black;
}
.breadcrumb-item + .breadcrumb-item::before {
  color: black;
}
</style>
